import getDecorators from 'inversify-inject-decorators';

import { rootContainer } from '../ioc';

import { EstimateStore } from './stores/estimate.store';

export const estimateContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(estimateContainer);

estimateContainer.bind(EstimateStore).toSelf().inSingletonScope();
